module.exports = __webpack_public_path__ + "img/banner.ace7811a.png";